<app-page padding="0" [canShowBreadcrumb]="canShowBreadcrumb">
  <div top-right>
    <ng-content select="[top-right]"></ng-content>
    <app-button [matMenuTriggerFor]="topRightMenu" class="mb-1" color="primary" icon="more_vert" *ngIf="refMenuActions.childElementCount"></app-button>
    <mat-menu #topRightMenu="matMenu">
      <div #refMenuActions>
        <ng-content select="[menu-actions]"></ng-content>
      </div>
    </mat-menu>
  </div>
  <div class="page-list p-0">
    <div class="flex w-12 p-2 align-items-center">
      <div class="col">
        <app-input-text *ngIf="canSearch" name="search" label="Ricerca" icon="search" [placeholder]="placeholderSearch" [form]="listPageForm" class="pb-0" clearable></app-input-text>
      </div>
      <div *ngIf="hasFilter === true" class="col-auto">
        <app-button color="primary" icon="tune" [fullWidth]="false" (click)="onFilterClick(filterRef)" [disabled]="!canFilter" [matBadge]="filtersApplied()" [matBadgeHidden]="filtersApplied() === 0" matBadgePosition="above" matBadgeSize="small"></app-button>
      </div>
    </div>
    <div class="page-list-content">
      <app-table *ngIf="!isSelectableTable" matSort [data]="list" [columns]="columns" [visibleColumns]="visibleColumns" (sort)="handleSortEvent($event)" [sortInitialState]="sortState" [rowClick]="(canShowDetail && hasPrimaryKey) ? onRowClick.bind(this) : undefined">
        <ng-content></ng-content>
      </app-table>
      <app-table-select *ngIf="isSelectableTable" (myIdEditEvent)="selectedIdCheckBox($event)" matSort [data]="list" [columns]="columns" [visibleColumns]="visibleColumns" (sort)="handleSortEvent($event)" [sortInitialState]="sortState" [rowClick]="(canShowDetail && hasPrimaryKey) ? onRowClick.bind(this) : undefined">
        <ng-content></ng-content>
      </app-table-select>
    </div>
  </div>
  <div footer>
    <div class="flex justify-content-between w-full">
      <div class="md:px-2">
        <app-paginator-sentrynel *ngIf="checkQueryServiceSentrynel" (page)="handlePageEvent($event)" [pageable]="pageable"></app-paginator-sentrynel>
        <app-paginator *ngIf="!checkQueryServiceSentrynel" (page)="handlePageEvent($event)" [pageable]="pageable"></app-paginator>
      </div>
      
      <div class="flex">
        <div class="flex gap-1 pr-2" *ngIf="canImport">
          <app-button *ngIf="canImportExcel" [fullWidth]="false" raised color="primary" label="Importa Excel" icon="arrow_right_alt" (click)="showDialogImportaExcel()"></app-button>
        </div>
        <!--inizio-->
        <div *ngIf="canExport" class="pr-2">
          <app-button [matMenuTriggerFor]="bottomRightMenu" raised [fullWidth]="false"  color="primary" label="Esporta Excel" icon="download" ></app-button>
          <mat-menu #bottomRightMenu="matMenu">
            <div #refMenuActions>
              <button mat-menu-item (click)="esportaExcel()">{{ excelBtnTitle }}</button>
              <!-- <button mat-menu-item>Item 2</button> -->
            </div>
          </mat-menu>
        </div>
        <!--fine-->
        <div class="flex gap-1 pr-2" *ngIf="canInsert">
          <ng-content select="[bottom-right]"></ng-content>
          <app-button icon="add" [fullWidth]="false" miniFab (click)="onInsertClick(insertRef)" [disabled]="!hasCrud()"></app-button>
        </div>
        <div class="flex gap-1 pr-2" *ngIf="canUpdate">
          <ng-content select="[bottom-right]"></ng-content>
          <app-button icon="edit" [fullWidth]="false" miniFab (click)="onEditClick(editRef)" [disabled]="!hasCrud()"></app-button>
        </div>
      </div>
    </div>
  </div>
</app-page>

<ng-template #filterRef>
  <app-sidenav title="filtri" [padding]="0" [className]="'w-full'">
    <div header *ngIf="isFiltersApplied()">
      <app-button label="Cancella filtri" fullWidth (click)="onResetFilterClick()"></app-button>
    </div>
    <div class="flex flex-column gap-3 align-items-center w-full">
      <div #filtersRef class="w-full">
        <ng-content select="[filters]"></ng-content>
      </div>
    </div>
    <div footer>
      <div class="flex justify-content-center gap-1">
        <app-button label="Applica" raised fullWidth cdkFocusRegionstart (click)="onApplyFilterClick()"></app-button>
      </div>
    </div>
  </app-sidenav>
</ng-template>

<ng-template #insertRef>
  <app-sidenav [title]="'aggiungi nuovo ' + insertFormTitle" [padding]="0" [className]="'w-full'">
    <div class="flex flex-column gap-3 align-items-center w-full">
      <div #insertFormRef class="w-full p-2">
        <ng-content select="[insert-form]"></ng-content>
      </div>
    </div>
    <div footer>
      <div class="flex justify-content-center">
        <app-button label="Salva" raised fullWidth cdkFocusRegionstart (click)="onSaveClick()" [disabled]="!insertForm?.valid"></app-button>
      </div>
    </div>
  </app-sidenav>
</ng-template>

<ng-template #editRef>
  <app-sidenav [title]="'Modifica nuovo ' + insertFormTitle" [padding]="0" [className]="'w-full'">
    <div class="flex flex-column gap-3 align-items-center w-full">
      <div #editFormRef class="w-full p-2">
        <ng-content select="[edit-form]"></ng-content>
      </div>
    </div>
    <div footer>
      <div class="flex justify-content-center">
        <app-button label="Salva" raised fullWidth cdkFocusRegionstart (click)="onSaveClick()" [disabled]="!insertForm?.valid"></app-button>
      </div>
    </div>
  </app-sidenav>
</ng-template>